/* Squishy theme — vanilla JS, no dependencies. */
(() => {
  const theme = window.theme || {};
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  /* ---------------------------------------------------------------- Money */
  function formatMoney(cents) {
    const format = theme.moneyFormat || '${{amount}}';
    const value = Number(cents) / 100;
    const withDelims = (n, decimals, thousands = ',', decimal = '.') => {
      const [int, frac] = n.toFixed(decimals).split('.');
      return int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (frac ? decimal + frac : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return withDelims(value, 0);
        case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelims(value, 2, "'", '.');
        default: return withDelims(value, 2);
      }
    });
  }

  /* ---------------------------------------------------------------- Toast */
  let toastTimer;
  function toast(message) {
    const el = $('#Toast');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { el.hidden = true; }, 2800);
  }

  /* -------------------------------------------------------------- Drawers */
  let lastFocus = null;
  function openDrawer(drawer) {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
    $$(`[aria-controls="${drawer.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
    const focusable = $('.drawer__close', drawer);
    if (focusable) setTimeout(() => focusable.focus(), 50);
  }
  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) document.body.classList.remove('overflow-hidden');
    $$(`[aria-controls="${drawer.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
    if (lastFocus) lastFocus.focus();
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(document.getElementById(opener.dataset.drawerOpen));
      return;
    }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      e.preventDefault();
      closeDrawer(closer.closest('.drawer'));
      return;
    }
    const cartOpener = e.target.closest('[data-cart-open]');
    if (cartOpener && theme.cartType === 'drawer') {
      e.preventDefault();
      openDrawer($('#CartDrawer'));
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') $$('.drawer.is-open').forEach(closeDrawer);
  });

  /* ----------------------------------------------------------------- Cart */
  const cartDrawer = () => $('#CartDrawer');

  function renderCartDrawer(sections) {
    if (!sections || !sections['cart-drawer']) return;
    const html = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    const fresh = $('[data-cart-contents]', html);
    const current = $('#CartDrawer [data-cart-contents]');
    if (fresh && current) {
      current.innerHTML = fresh.innerHTML;
      current.dataset.itemCount = fresh.dataset.itemCount;
      updateCartCount(Number(fresh.dataset.itemCount));
    }
  }

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.dataset.count = count;
      el.textContent = count > 0 ? count : '';
    });
  }

  async function addToCart(formData, button) {
    if (button) button.classList.add('is-loading');
    formData.append('sections', 'cart-drawer');
    formData.append('sections_url', window.location.pathname);
    try {
      const res = await fetch(`${theme.routes.cartAdd}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || theme.strings.error);

      if (theme.cartType === 'page') {
        window.location.href = theme.routes.cart;
        return;
      }
      renderCartDrawer(data.sections);
      openDrawer(cartDrawer());
      return data;
    } catch (err) {
      toast(err.message || theme.strings.error);
      throw err;
    } finally {
      if (button) button.classList.remove('is-loading');
    }
  }

  async function changeLine(key, quantity) {
    const drawer = cartDrawer();
    const panel = drawer && $('[data-cart-contents]', drawer);
    if (panel) panel.style.opacity = '0.6';
    try {
      const res = await fetch(`${theme.routes.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: ['cart-drawer'], sections_url: window.location.pathname }),
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || theme.strings.error);
      if ($('[data-cart-page]')) {
        window.location.reload();
        return;
      }
      renderCartDrawer(data.sections);
    } catch (err) {
      toast(err.message || theme.strings.error);
    } finally {
      if (panel) panel.style.opacity = '';
    }
  }

  // Quick add (cards, upsells) and main product form.
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!form.matches('[data-quick-add], [data-product-form]')) return;
    e.preventDefault();
    const button = $('[type="submit"]', form);
    if (button && button.disabled) return;
    const errorEl = $('[data-form-error]', form);
    if (errorEl) errorEl.hidden = true;
    addToCart(new FormData(form), button).catch((err) => {
      if (errorEl) {
        errorEl.textContent = err.message;
        errorEl.hidden = false;
      }
    });
  });

  // Line item quantity / remove (drawer and cart page).
  document.addEventListener('click', (e) => {
    const line = e.target.closest('[data-line-key]');
    if (!line) return;
    const input = $('[data-line-qty]', line);
    const step = e.target.closest('[data-qty-change]');
    if (step) {
      const next = Math.max(0, Number(input.value) + Number(step.dataset.qtyChange));
      input.value = next;
      changeLine(line.dataset.lineKey, next);
    } else if (e.target.closest('[data-line-remove]')) {
      changeLine(line.dataset.lineKey, 0);
    }
  });
  document.addEventListener('change', (e) => {
    if (!e.target.matches('[data-line-qty]')) return;
    const line = e.target.closest('[data-line-key]');
    changeLine(line.dataset.lineKey, Math.max(0, Number(e.target.value)));
  });

  /* -------------------------------------------------------- Product page */
  function initProduct(root) {
    const section = $('[data-product-section]', root);
    if (!section || section.dataset.bound) return;
    section.dataset.bound = 'true';

    const sectionId = section.dataset.sectionId;
    const form = $('[data-product-form]', section);
    const idInput = form && $('[data-variant-id]', form);
    const addButton = form && $('[data-add-button]', form);
    const addLabel = addButton && $('[data-add-label]', addButton);
    const picker = $('[data-variant-picker]', section);
    const mainImage = $('[data-main-image]', section);
    const sticky = $('[data-sticky-atc]');
    const variantsEl = picker && $('[data-variants-json]', picker);
    const variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];

    // Quantity stepper
    $$('[data-qty-step]', section).forEach((btn) => {
      btn.addEventListener('click', () => {
        const input = $('[data-qty-input]', section);
        input.value = Math.max(1, Number(input.value || 1) + Number(btn.dataset.qtyStep));
      });
    });

    // Gallery thumbnails
    function showMedia(src, srcset, mediaId) {
      if (!mainImage) return;
      mainImage.src = src;
      if (srcset) mainImage.srcset = srcset;
      $$('[data-thumb]', section).forEach((t) => t.setAttribute('aria-current', String(t.dataset.mediaId === String(mediaId))));
    }
    $$('[data-thumb]', section).forEach((thumb) => {
      thumb.addEventListener('click', () => showMedia(thumb.dataset.src, thumb.dataset.srcset, thumb.dataset.mediaId));
    });

    function setButtonState(variant) {
      if (!addButton) return;
      if ('restocking' in section.dataset) return;
      const available = variant && variant.available;
      addButton.disabled = !available;
      const label = !variant ? theme.strings.unavailable : available ? theme.strings.addToCart : theme.strings.soldOut;
      if (addLabel) addLabel.textContent = label;
      if (sticky) {
        const sb = $('[data-sticky-add]', sticky);
        sb.disabled = !available;
        sb.textContent = label;
        if (variant) $('[data-sticky-price]', sticky).textContent = formatMoney(variant.price);
      }
    }

    function markAvailability(selected) {
      if (!picker) return;
      $$('input[type="radio"]', picker).forEach((input) => {
        const idx = Number(input.dataset.optionIndex);
        const candidate = selected.slice();
        candidate[idx] = input.value;
        const match = variants.some((v) => v.available && v.options.every((o, i) => o === candidate[i]));
        input.classList.toggle('is-unavailable', !match);
      });
    }

    async function refreshSection(variantId) {
      try {
        const res = await fetch(`${window.location.pathname}?variant=${variantId}&section_id=${sectionId}`);
        const html = new DOMParser().parseFromString(await res.text(), 'text/html');
        ['[data-price-wrapper]', '[data-inventory]'].forEach((sel) => {
          const fresh = $(sel, html);
          const current = $(sel, section);
          if (fresh && current) current.innerHTML = fresh.innerHTML;
        });
      } catch (_) { /* non-critical */ }
    }

    function onOptionChange() {
      const selected = $$('fieldset', picker).map((fs) => {
        const checked = $('input:checked', fs);
        return checked ? checked.value : null;
      });
      selected.forEach((val, i) => {
        const label = $(`[data-option-label="${i}"]`, picker);
        if (label) label.textContent = val;
      });
      const variant = variants.find((v) => v.options.every((o, i) => o === selected[i]));
      markAvailability(selected);
      setButtonState(variant);
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      const installments = $('#InstallmentsForm input[name="id"]');
      if (installments) installments.value = variant.id;
      if (variant.featured_media) {
        const src = variant.featured_media.preview_image.src;
        const sep = src.includes('?') ? '&' : '?';
        showMedia(`${src}${sep}width=1400`, `${src}${sep}width=700 700w, ${src}${sep}width=1400 1400w`, variant.featured_media.id);
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
      refreshSection(variant.id);
    }

    if (picker) {
      picker.addEventListener('change', onOptionChange);
      markAvailability($$('fieldset', picker).map((fs) => ($('input:checked', fs) || {}).value));
    }

    // Mobile sticky add-to-cart: shows once the main button scrolls out of view.
    if (sticky && addButton && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(([entry]) => {
        const past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', past);
        sticky.setAttribute('aria-hidden', String(!past));
      });
      io.observe(addButton);
      $('[data-sticky-add]', sticky).addEventListener('click', () => {
        if (form.requestSubmit) form.requestSubmit(addButton);
        else addButton.click();
      });
    }
  }

  /* -------------------------------------------------- Recommendations */
  function initRecommendations(root) {
    $$('[data-recommendations]', root).forEach(async (el) => {
      if (el.dataset.loaded) return;
      el.dataset.loaded = 'true';
      try {
        const res = await fetch(el.dataset.url);
        const html = new DOMParser().parseFromString(await res.text(), 'text/html');
        const fresh = $('[data-recommendations]', html);
        if (fresh && fresh.innerHTML.trim()) {
          el.innerHTML = fresh.innerHTML;
        } else {
          el.remove();
        }
      } catch (_) {
        el.remove();
      }
    });
  }

  /* ------------------------------------------------------- Collection */
  document.addEventListener('change', (e) => {
    if (!e.target.matches('[data-sort-select]')) return;
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', e.target.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* ---------------------------------------------------- Announcement */
  function initAnnouncement(root) {
    $$('[data-announcement]', root).forEach((bar) => {
      const items = $$('.announcement__item', bar);
      if (items.length < 2 || bar.dataset.bound) return;
      bar.dataset.bound = 'true';
      let i = 0;
      setInterval(() => {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, Number(bar.dataset.speed || 4) * 1000);
    });
  }

  /* ---------------------------------------------------------- Header */
  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 10);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------------------------------------------------------- Reveal */
  function initReveal(root) {
    const els = $$('.reveal:not(.is-visible)', root);
    if (!('IntersectionObserver' in window)) {
      els.forEach((el) => el.classList.add('is-visible'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach((el) => io.observe(el));
  }

  /* ------------------------------------------------------------ Init */
  function init(root = document) {
    initProduct(root);
    initRecommendations(root);
    initAnnouncement(root);
    initReveal(root);
  }

  init();

  // Theme editor support
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:section:select', (e) => {
    const drawer = $('.drawer', e.target);
    if (drawer && drawer.id === 'CartDrawer') openDrawer(drawer);
  });
})();
